/**
 * Coil Configurator with Technical sub-tabs (Heat Profile, Test Repository, DCAL, Coil Configurator).
 */

import React from 'react';
import CoilConfiguratorPage from '../../components/CoilConfigurator/CoilConfiguratorPage';
import TechnicalSubTabs from './TechnicalSubTabs';
import './HeatProfilePage.css';

const CoilConfiguratorTechnicalPage = () => (
    <div className="heat-profile-page coil-configurator-technical-page">
        <TechnicalSubTabs />
        <div className="heat-profile-content-wrapper">
            <CoilConfiguratorPage />
        </div>
    </div>
);

export default CoilConfiguratorTechnicalPage;
